export default (context, data) => {
    context.musics = context.musics.map((item, index) => {
        if(data.index === index) {
            let arr = item
            arr.status = true
            return arr
        } else {
            let arr = item
            arr.status = false
            return arr
        }
    });
}